import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import { Link } from "@tanstack/react-router";
import { formatDate } from "@/shared/lib/date-time";
import type { StudentPackagesReportItemDTO } from "../api/client";
import {
  formatStudentPackageMoney,
} from "../lib/student-packages-export";

type StudentPackagesReportTableProps = {
  isLoading: boolean;
  data: StudentPackagesReportItemDTO[];
};

function formatUsedRemaining(row: StudentPackagesReportItemDTO) {
  if (row.unitType === "hour") {
    return {
      used: `${row.usedUnits} ຊົ່ວໂມງ`,
      remaining: `${row.remainingUnits} ຊົ່ວໂມງ`,
    };
  }
  return {
    used: `${row.usedUnits} ຄັ້ງ`,
    remaining: `${row.remainingUnits} ຄັ້ງ`,
  };
}

export function StudentPackagesReportTable({
  isLoading,
  data,
}: StudentPackagesReportTableProps) {
  return (
    <div className="overflow-x-auto rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ນັກຮຽນ</TableHead>
            <TableHead>ແພັກເກດ</TableHead>
            <TableHead>ຄລາສ/ຮຽນ</TableHead>
            <TableHead className="text-right">ຈ່າຍແລ້ວ</TableHead>
            <TableHead className="text-right">ຄ້າງຊຳລະ</TableHead>
            <TableHead>ວັນທີຈ່າຍ</TableHead>
            <TableHead className="text-right">ເຂົ້າແລ້ວ</TableHead>
            <TableHead className="text-right">ຄົງເຫຼືອ</TableHead>
            <TableHead>ວັນໝົດອາຍຸ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={9}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={9}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => {
              const units = formatUsedRemaining(row);
              return (
                <TableRow key={`${row.packageType}-${row.packageId}`}>
                  <TableCell>
                    <Link
                      to="/app/students/$id"
                      params={{ id: row.studentId }}
                      className="font-medium hover:underline"
                    >
                      {row.studentName}
                    </Link>
                    <div className="text-muted-foreground text-xs">
                      {row.memberId}
                    </div>
                  </TableCell>
                  <TableCell>
                    {row.packageName}
                    <div className="text-muted-foreground text-xs">
                      {row.packageType === "package"
                        ? "ແພັກເກດຄລາດສ໌"
                        : "ແພັກເກດຮຽນສ່ວນຕົວ"}
                    </div>
                  </TableCell>
                  <TableCell className="max-w-[220px] whitespace-normal text-sm">
                    {row.studyDescription}
                  </TableCell>
                  <TableCell className="text-right tabular-nums">
                    {formatStudentPackageMoney(row.paidAmount)}
                  </TableCell>
                  <TableCell className="text-right tabular-nums">
                    {row.unpaidAmount > 0 ? (
                      <span className="text-destructive">
                        {formatStudentPackageMoney(row.unpaidAmount)}
                      </span>
                    ) : (
                      formatStudentPackageMoney(0)
                    )}
                  </TableCell>
                  <TableCell className="whitespace-nowrap tabular-nums">
                    {row.paidAt ? formatDate(row.paidAt) : "—"}
                  </TableCell>
                  <TableCell className="text-right tabular-nums">
                    {units.used}
                  </TableCell>
                  <TableCell className="text-right tabular-nums">
                    {units.remaining}
                  </TableCell>
                  <TableCell className="whitespace-nowrap tabular-nums">
                    {row.expireDate}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </div>
  );
}
